import moment from 'moment';
import RestService from '../services/rest';

async function getMonitorDocuments(startDate, endDate) {
  const sDate = moment(startDate).format();
  const eDate = moment(endDate).format();

  return RestService.getAuthenticated(
    'outboundOrderLoadSimplified/getMonitorDocuments',
    {
      startDate: sDate,
      endDate: eDate,
    }
  );
}

async function getMonitorProducts(outboundOrderLoadSimplifiedId) {
  return RestService.getAuthenticated(
    'outboundOrderLoadSimplified/getMonitorProducts',
    {
      outboundOrderLoadSimplifiedId,
    }
  );
}

async function cancelDocument(outboundOrderLoadSimplifiedId) {
  return RestService.postAuthenticated(
    'outboundOrderLoadSimplified/cancelDocument',
    {
      outboundOrderLoadSimplifiedId,
    },
  );
}

async function cancelProduct(outboundOrderLoadSimplifiedProductId) {
  return RestService.postAuthenticated(
    'outboundOrderLoadSimplified/cancelProduct',
    {
      outboundOrderLoadSimplifiedProductId,
    },
  );
}

async function generateOutboundOrderFromLoad(outboundOrderLoadSimplifiedIds) {
  return RestService.postAuthenticated(
    'outboundOrderLoadSimplified/generateOutboundOrderFromLoad',
    {
      outboundOrderLoadSimplifiedIds,
    }
  );
}

export default {
  getMonitorDocuments,
  getMonitorProducts,
  generateOutboundOrderFromLoad,
  cancelDocument,
  cancelProduct,
};
